var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavEnemySvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    width: "800px",
    height: "800px",
    viewBox: "0 0 33.867 33.867",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.906 3.2795-6.5066 14.145-8.507-6.6125s3.3913 7.6939 3.5977 9.3798c1.6593-0.60717 2.9748 0.42865 3.5982 2.1146 0.54544 1.475 0.21486 2.9267-1.5043 4.1693 0.47187 1.1342 0.29507 1.1343 0.29507 1.1343s-1.0324 0.67414-0.26562 1.1033c0.38203 0.21381 1.9922 0.70844 3.8592 1.1508l0.63665-0.5364-0.29817-1.3276 1.0051 1.464-0.68678 0.54519c1.7074 0.38022 3.5252 0.69298 4.7765 0.69298 2.8143 0 8.5794-1.5599 9.3462-1.989 0.76678-0.42915-0.2651-1.1033-0.2651-1.1033s-0.17731-1.27e-4 0.29456-1.1343c-1.7192-1.2425-2.0492-2.6943-1.5038-4.1693 0.62345-1.6859 1.9384-2.7218 3.5977-2.1146 0.20644-1.6859 3.5982-9.3798 3.5982-9.3798l-8.5618 6.6125-2.5445-5.5712-0.65216 1.0857-0.03152-2.2397zm0 13.148 4.7961 7.7163-4.7961 5.0069-4.7966-5.0069zm0 2.8846-2.8572 4.8338 2.8572 3.3161 2.8572-3.3161zm-11.072 1.7105c-0.080784-9.98e-4 -0.16406 0.0018-0.25063 0.0078l-3.4127 2.9615 5.0581 1.5425c1.1517-0.88501 1.041-2.1005 0.70642-2.9311-0.31544-0.78301-0.88939-1.5653-2.1012-1.5808zm22.198 0c-1.2118 0.01549-1.7857 0.79777-2.1012 1.5808-0.33462 0.83062-0.44473 2.0461 0.70694 2.9311l5.0576-1.5425-3.4122-2.9616c-0.08657-6e-3 -0.17036-0.0089-0.25115-0.0078z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavEnemySvg1);
export default __webpack_public_path__ + "static/media/nav-enemy-svg-1.7c9a41ce827aa9b7b301216e7b7eee6a.svg";
export { ForwardRef as ReactComponent };